import { Facebook, Link2, Share2 } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "@/lib/i18n";

const btn =
  "inline-flex items-center gap-2 rounded-full border px-4 py-2.5 min-h-[40px] font-mono text-[11px] font-bold uppercase tracking-[0.15em] transition-[background-color,color,border-color,transform] duration-200 hover:scale-[1.03] active:scale-95";

export const ShareButtons = ({ dark = false }) => {
  const { t } = useLang();
  const shareUrl = () => `${window.location.origin}/#gallery`;
  const canNativeShare = typeof navigator !== "undefined" && !!navigator.share;

  const facebook = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl())}`,
      "_blank",
      "noopener,noreferrer,width=640,height=560"
    );
  };

  const native = async () => {
    try {
      await navigator.share({ title: t("share_title"), text: t("share_text"), url: shareUrl() });
    } catch {
      /* user dismissed */
    }
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl());
      toast.success(t("share_copied"));
    } catch {
      toast.error(t("share_copy_fail"));
    }
  };

  const base = dark
    ? "border-white/20 text-slate-200 hover:border-[#F26522] hover:text-white"
    : "border-[#0E1A2B]/20 text-[#0E1A2B] hover:border-[#F26522] hover:text-[#F26522]";

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="share-buttons">
      <span className={`font-mono text-[11px] uppercase tracking-[0.2em] mr-1 ${dark ? "text-slate-400" : "text-[#475569]"}`}>
        {t("share_label")}
      </span>
      <button onClick={facebook} className={`${btn} ${base}`} data-testid="share-facebook-btn">
        <Facebook className="h-3.5 w-3.5" /> Facebook
      </button>
      {canNativeShare && (
        <button onClick={native} className={`${btn} ${base}`} data-testid="share-native-btn">
          <Share2 className="h-3.5 w-3.5" /> {t("share_more")}
        </button>
      )}
      <button onClick={copy} className={`${btn} ${base}`} data-testid="share-copy-btn">
        <Link2 className="h-3.5 w-3.5" /> {t("share_copy")}
      </button>
    </div>
  );
};
